import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	listViewTitle: {
		id: 'spa-apps-jsw-list.page-header.list-view-title',
		defaultMessage: 'List',
		description: 'Title for the list view on JSW',
	},
});
